export const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL as string;
export const REACT_APP_API_PANEL_URL = process.env.REACT_APP_API_PANEL_URL as string;
export const REACT_APP_IO_URL = process.env.REACT_APP_IO_URL as string;
export const REACT_APP_PROJECT_NAME = process.env.REACT_APP_PROJECT_NAME as string;

export const PHOTO_PLACEHOLDER = '/assets/placeholder-photo.jpg';

export const TEST_DATA = 'TEST_DATA';

export const AUTH_TOKEN_KEY = 'AUTH_TOKEN_KEY';

export const API_DATE_FORMAT = 'yyyy-mm-dd';
export const FRONT_DATE_FORMAT = 'dd.mm.yyyy';

export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_ITEMS = '8';
